import dayjs from 'dayjs';

export default {
    changeLoading: (state, { item, isLoading }) => {
        state.loading[item] = isLoading;
    },
    updateList: (state, { posts, total_posts, total_pages }) => {
        state.totalPosts = parseInt(total_posts);
        state.totalPages = parseInt(total_pages);
        state.list = posts;
    },
    updateMetaList(state, { index, data, name }) {
        const valueList = [];
        const idLookupObject = {};

        data.forEach(({ id, name }) => {
            idLookupObject[id] = name;

            valueList.push({
                id,
                value: id,
                active: false,
            });
        });

        state.filters[index].value = valueList;
        state[name] = idLookupObject;
    },
    changePage: (state, value) => {
        state.page = value;
    },
    updateSearchQuery: (state, { value }) => {
        state.searchQuery = value;
    },
    toggleListFilterItem: (
        state,
        { filterIndex, optionIndex, updateQuery = true }
    ) => {
        const filterList = [...state.filters];

        if (updateQuery) {
            const filterName = filterList[filterIndex].name;
            const value = decodeURIComponent(
                filterList[filterIndex].value[optionIndex].value
            );
            const queryString = Object.assign({}, window.urlQueryString);

            if (typeof queryString[filterName] == 'undefined') {
                // filter isn't in the query string yet
                queryString[filterName] = [value];
            } else {
                // filter is in query string, toggle the value
                const queryOptionIndex = queryString[filterName].indexOf(
                    encodeURIComponent(value)
                );

                if (queryOptionIndex == -1) {
                    queryString[filterName].push(value);
                } else {
                    queryString[filterName].splice(queryOptionIndex, 1);
                }

                // Don't leave empty queries
                if (queryString[filterName].length == 0)
                    delete queryString[filterName];
            }

            window.urlQueryString = queryString;
        }

        filterList[filterIndex].value[optionIndex].active = !filterList[
            filterIndex
        ].value[optionIndex].active;

        state.filters = filterList;
    },
    clearListFilter: (state, { filterIndex }) => {
        const filterList = [...state.filters];

        filterList[filterIndex].value.forEach((val) => {
            val.active = false;
        });

        const queryString = Object.assign({}, window.urlQueryString);

        delete queryString[filterList[filterIndex].name];

        window.urlQueryString = queryString;

        state.filters = filterList;
    },
    updateFilterValue: (state, { value, filterIndex, updateQuery = true }) => {
        const filterList = [...state.filters];

        filterList[filterIndex].value = value;

        if (updateQuery) {
            // Logic is a bit different from list items, just change the val.
            // This logic is much friendlier than the list one
            const filterName = filterList[filterIndex].name;
            const queryString = Object.assign({}, window.urlQueryString);

            if (value) {
                queryString[encodeURIComponent(filterName)] =
                    filterList[filterIndex].type == 'date'
                        ? [dayjs(value).format('YYYY-MM-DD')]
                        : [value];
            } else {
                delete queryString[encodeURIComponent(filterName)];
            }

            window.urlQueryString = queryString;
        }

        state.filters = filterList;
    },
    toggleFilterState: (state, index) => {
        const updatedFilters = [...state.filters];
        updatedFilters[index].state = !updatedFilters[index].state;
        state.filters = updatedFilters;
    },
    closeFilter: (state, index) => {
        const updatedFilters = [...state.filters];
        updatedFilters[index].state = false;
        state.filters = updatedFilters;
    },
};
